/* eslint-disable */
import debounce from 'extensions/debounce/debounce';
import { getParent, getNextSibling } from 'extensions/selector/selector';
import 'element-matches-polyfill';

export class TransfigureNavigation {

	/**
	 * options.menu
	 * options.parentMenuItems
	 * options.menuLink
	 * options.mainMenuOpenButton
	 * options.mainMenuCloseButton
	 * options.showPreviousMenuButtons
	 */
	constructor( options ) {
		
		if ( options == null ) {
			throw new Error( '[TransfigureNavigation].constructor - Missing parameter `options`.' );
		}
		if ( options.menu == null || (typeof options.menu !== 'string') ) {
			throw new Error( '[TransfigureNavigation].constructor - Invalid type for option `menu`. Must be a selector string.' );
		}
		if ( options.parentMenuItems == null || (typeof options.parentMenuItems !== 'string') ) {
			throw new Error( '[TransfigureNavigation].constructor - Invalid type for option `parentMenuItems`. Must be a selector string.' );
		}
		if ( options.menuLink == null || (typeof options.menuLink !== 'string') ) {
			throw new Error( '[TransfigureNavigation].constructor - Invalid type for option `menuLink`. Must be a selector string.' );
		}
		if ( options.mainMenuOpenButton == null || (typeof options.mainMenuOpenButton !== 'string' ) ) {
			throw new Error( '[TransfigureNavigation].constructor - Invalid type for option `mainMenuOpenButton`. Must be a selector string.' );
		}
		if ( options.mainMenuCloseButton == null || (typeof options.mainMenuCloseButton !== 'string') ) {
			throw new Error( '[TransfigureNavigation].constructor - Invalid type for option `mainMenuCloseButton`. Must be a selector string.' );
		}
		if ( options.showPreviousMenuButtons == null || (typeof options.showPreviousMenuButtons !== 'string') ) {
			throw new Error( '[TransfigureNavigation].constructor - Invalid type for option `showPreviousMenuButtons`. Must be a selector string.' );
		}

		this.options = options;
		this.options.breakpoint = options.breakpoint || 960;

		this.elements = {
			menu: document.querySelector( options.menu ),
			parentMenuItems: document.querySelectorAll( options.parentMenuItems ),
			mainMenuOpenButton: document.querySelector( options.mainMenuOpenButton ),
			mainMenuCloseButton: document.querySelector( options.mainMenuCloseButton ),
			showPreviousMenuButtons: document.querySelectorAll( options.showPreviousMenuButtons )
		};
		
		this.setClientPort();
		this.bindEvents();
		
		if ( this.shouldTrigger() ) {
			this.showSubnavigation();
		}

	}

	setClientPort() {
		this.clientPort = document.documentElement.clientWidth;
	}
	
	shouldTrigger() {
		return this.clientPort < this.options.breakpoint;
	}

	showSubnavigation() {
		
		// parent menu items
		for ( let parentMenuItem of this.elements.parentMenuItems ) {

			let links =	Array.from( parentMenuItem.children ).filter(( link ) => {
				return link.matches( this.options.menuLink );
			});

			for ( let link of links ) {

				link.addEventListener( 'click', this.onLinkClick, false );

			}

		}

		// show previous button
		for ( let showPreviousMenuButton of this.elements.showPreviousMenuButtons ) {

			showPreviousMenuButton.addEventListener( 'click', this.onPreviousButtonClick, false );

		}
		

	}

	bindEvents() {

		// resize event
		window.addEventListener( 'resize', debounce( 66, e => this.onResize( e ) ), false );

		// open and close events
		this.elements.mainMenuOpenButton.addEventListener( 'click', e => this.onOpen( e ), false );
		this.elements.mainMenuCloseButton.addEventListener( 'click', e => this.onClose( e ), false );

	}

	onResize( e ) {

		this.setClientPort();

		if ( this.shouldTrigger() ) {
			this.showSubnavigation();
		}

	}

	onOpen( e ) {

		e.preventDefault();

		document.documentElement.classList.add( 'has-open-main-menu' );
		this.elements.menu.classList.add( 'is-open' );

	}

	onClose( e ) {

		e.preventDefault();

		document.documentElement.classList.remove( 'has-open-main-menu' );
		this.elements.menu.classList.remove( 'is-open' );

	}

	onLinkClick( e ) {

		e.preventDefault();

		let selected = this;

		let nextList = getNextSibling( selected, 'ul' );
		if ( nextList ) {

			nextList.classList.remove( 'is-hidden' );

		}

		let parent = getParent( selected, '.has-child-menu' );
		let parentList = parent.closest( 'ul' );

		if ( parentList ) {

			parentList.classList.add( 'show-next' );

		}

	}

	onPreviousButtonClick( e ) {

		e.preventDefault();

		let selected = this;

		let parentList = getParent( selected, 'ul' );
		parentList.classList.add( 'is-hidden' );

		let parentMenu = getParent( parentList, '.has-child-menu' );
		let parentMenuList = parentMenu.closest( 'ul' );

		if ( parentMenuList ) {

			parentMenuList.classList.remove( 'show-next' );

		}

	}

};